module.exports = __webpack_public_path__ + "media/images/mailers/digital_contract_info/credit_card-1b5e7abf8a044549439f346da20cad26.png";